// formSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormState {
  isFormSubmitted: boolean;
}

const initialState: FormState = {
  isFormSubmitted: false,
};

export const formSubmittedSlice = createSlice({
  name: 'formSubmitted',
  initialState,
  reducers: {
    setFormSubmitted: (state, action: PayloadAction<boolean>) => {
      state.isFormSubmitted = action.payload;
    },
  },
});

export const { setFormSubmitted } = formSubmittedSlice.actions;

export default formSubmittedSlice.reducer;
